module.exports = __webpack_public_path__ + "img/prod_info_hlwyy.3fdbc27e.svg";